export default "__VITE_ASSET__ig$99gmr__"